export enum Colors {
    DARK_RED = "#880E4F",
    RED = "#D81B60",
    GREEN = "#2E7D32",
    DARK_GREEN = "#004D40",
    LIGHT_BLUE = "#0277BD",
    BLUE = "#0D47A1",
    DARK_BLUE = "#1A237E",
    INDIGO = "#304FFE",
    DARK_PURPLE = "#673AB7",
    PURPLE = "#8E24AA",
    PINK = "#C2185B",
}

export enum InternalReviewButtonColors {
    BUTTON = "rgba(245, 245, 245, 1)",
    BORDER = "1px solid rgba(117, 117, 117, 1)",
    COLOR = "rgba(16, 24, 40, 1)",
}
